{
  "page_count": "／ {n, plural, one{# ページ} other{# ページ}}"
}
